module.exports = __webpack_public_path__ + "img/sh.c867ada4.svg";